import DomainCommon from "./common";

const CompanyService = {

    list: function () {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getApiUrl()}/company`,
                params: undefined,
                resolve, reject
            });
        });
    },
    findById: async (id) => {

        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getApiUrl()}/company/${id}`,
                params: undefined,
                resolve, reject
            });
        });
    },
    add: async (company) => {

        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getApiUrl()}/company`,
                params: undefined,
                jsonBody: company,
                resolve, reject
            });
        });
    },
    update: async (id, company) => {

        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPatch({
                url: `${DomainCommon.getApiUrl()}/company/${id}`,
                params: undefined,
                jsonBody: company,
                resolve, reject
            });
        });
    },
    deleteById: async (id) => {

        return new Promise((resolve, reject) => {
            return DomainCommon.fetchDelete({
                url: `${DomainCommon.getApiUrl()}/company/${id}`,
                params: undefined,
                jsonBody: undefined,
                resolve, reject
            });
        });
    },
};

export default CompanyService;
